import { render } from "./UpsellPage.vue?vue&type=template&id=d7686938&scoped=true"
import script from "./UpsellPage.vue?vue&type=script&lang=js"
export * from "./UpsellPage.vue?vue&type=script&lang=js"

import "./UpsellPage.vue?vue&type=style&index=0&id=d7686938&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7686938"]])

export default __exports__